/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Share_TitleInputs */

const en_platform_step_share_title = /** @type {(inputs: Platform_Step_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send the link`)
};

const pl_platform_step_share_title = /** @type {(inputs: Platform_Step_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij link`)
};

/**
* | output |
* | --- |
* | "Send the link" |
*
* @param {Platform_Step_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_share_title = /** @type {((inputs?: Platform_Step_Share_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Share_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_share_title(inputs)
	return en_platform_step_share_title(inputs)
});